export const findNextLayoutGroup = (layouts, currentNumberOfFrames) =>
  layouts.filter((layout) => layout.numberOfFrames === currentNumberOfFrames + 1);
